import * as React from "react";
import {FormBodyProps} from "../../../common/props/FormBodyProps";
import SectionView from "../../../layout/section/SectionView";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Col from "../../../layout/Col";
import Row from "../../../layout/Row";
import CustomFieldForm from "./CustomFieldForm";
import FieldTypeFormGroup from "./FieldTypeFormGroup";
import CheckboxFormGroup from "../../../ui/form/CheckboxFormGroup";
import {CustomFieldType} from "../../../../model/customField/CustomField";
import EnumFieldOptionsFormGroup from "./EnumFieldOptionsFormGroup";
import {option} from "ts-option";
import {RequiredFormField} from "../../../../validation/FormField";

interface ComponentProps {
	editMode?: boolean
}

type Props = FormBodyProps<CustomFieldForm> & ComponentProps;

export default class CustomFieldFormBody extends React.PureComponent<Props> {
	render() {
		return (
			<SectionView>
				<Row>
					<Col xl={6} md={12}>
						<FieldTypeFormGroup label={"Type"}
											onChange={this.onTypeChange}
											field={this.props.form.fieldType}
											disabled={this.props.editMode}/>
					</Col>
					<Col xl={6} md={12}>
						<InputFormGroup label="Label"
										placeholder="Enter label"
										field={this.props.form.label}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.label)}/>
					</Col>
				</Row>
				<Row>
					<Col xl={12} md={12} style={{minHeight: "101px"}}>
						{this.props.form.fieldType.getValue() === CustomFieldType.ENUM &&
						<EnumFieldOptionsFormGroup label="Options"
												   placeholder="Add enum options"
												   field={this.props.form.options}
												   onChange={field => this.props.onFieldChange(field)}/>}
					</Col>
				</Row>
				<Row>
					<Col xl={6} md={12}>
						<CheckboxFormGroup field={this.props.form.disabledInWorkspace}
										   onChange={this.props.onFieldChange}
										   label={"Disable from workspace"}/>
					</Col>
					<Col xl={6} md={12}>
						<CheckboxFormGroup field={this.props.form.disabledInUi}
										   onChange={this.props.onFieldChange}
										   label={"Disable from UI"}/>
					</Col>
				</Row>
			</SectionView>
		);
	}

	onTypeChange = (typeField: RequiredFormField<CustomFieldType>) => {
		this.props.onFieldsChange([typeField, this.props.form.options.updateValue(option([]))]);
	};
}